export default __webpack_public_path__ + "static/media/gallery-3-2.343d1ea5.webp";